import { useState, useEffect } from 'react';
import { requestStatuses } from 'shared/../constants/store';

/**
 getData returns Promise
*/
const useDataLoadingState = (getData, autoLoad = true) => {
  const [status, setStatus] = useState(requestStatuses.INIT);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const load = () => {
    setStatus(requestStatuses.PENDING);
    setError(null);
    getData()
      .then((data) => {
        setData(data);
        setStatus(requestStatuses.SUCCESS);
      })
      .catch((error) => {
        setError(error);
        setStatus(requestStatuses.FAILED);
      });
  };

  useEffect(() => {
    if (autoLoad) {
      load();
    }
  }, []);

  const reload = () => load();

  return { status, error, data, reload, setData };
};

export default useDataLoadingState;
